export default [
  {
    path: '/payments',
    name: 'payments',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Оплаты',
    },
    children: [
      {
        path: 'add',
        name: 'add',
        component: () => import('@/views/payments/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
      {
        path: 'correcting',
        name: 'correcting',
        component: () => import('@/views/payments/correcting.vue'),
        meta: {
          title: 'Корректировка',
        },
      },
      {
        path: 'registry',
        name: 'registry',
        component: () => import('@/views/payments/registry.vue'),
        meta: {
          title: 'Реестр',
        },
      },
      {
        path: 'registry-list',
        name: 'registry-list',
        component: () => import('@/views/forms/registry-list.vue'),
        meta: {
          title: 'Реестр',
        },
      },
    ],
  },
]
